import { createContext } from "react";

export const XRouterContext = createContext(null);
